import React, { useCallback } from 'react';
import './Fog.css';

const Fog = ({ isVisible, children, text: TextComponent }) => {
    const handleFogClick = useCallback(e => e.preventDefault(), []);

    return isVisible ? (
        <div className="fog-container">
            <div className="text-container">
                <TextComponent />
            </div>
            {children}
        </div>
    ) : (
        children
    );
};

export default React.memo(Fog);
